// src/Services/invoiceService.js
import axios from "axios";
import AppSettings from "../appsettings";

const BASE_URL = `${AppSettings.API_BASE_URL}/Invoices`;


const invoiceService = {
  // Get all invoices (Admin)
  async getAll() {
    const res = await axios.get(`${BASE_URL}`);
    return res.data;
  },

  // Get invoices by publisher
  async getByPublisher(publisherId) {
    const res = await axios.get(`${BASE_URL}/publisher/${publisherId}`);
    return res.data;
  },

  // Create a new invoice
  async create(invoice) {
    const res = await axios.post(`${BASE_URL}`, invoice);
    return res.data;
  },

  // Update an invoice
  async update(id, updatedInvoice) {
    const res = await axios.put(`${BASE_URL}/${id}`, updatedInvoice);
    return res.data;
  },

  // Delete invoice
  async delete(id) {
    const res = await axios.delete(`${BASE_URL}/${id}`);
    return res.data;
  },
  async downloadInvoice(invoiceId) {
    try {
      debugger
      const res = await axios.get(`${BASE_URL}/download/${invoiceId}`, {
        responseType: 'arraybuffer',
      });

      const blob = new Blob([res.data], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(blob);
      window.open(fileURL, '_blank');

      // Option A: Trigger a download
      const link = document.createElement('a');
      link.href = fileURL;
      link.download = `Invoice-${invoiceId}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();

      // Clean up
      window.URL.revokeObjectURL(fileURL);
    } catch (error) {
      console.error('Error downloading invoice:', error);
    }
  },
  async viewInvoice(invoiceId) {
    // ✅ Open the window right away (inside click handler)
    const newWindow = window.open('', '_blank');
    if (!newWindow) {
      alert('Popup blocked! Please allow popups for this site.');
      return;
    }

    try {
      // 🔹 Fetch HTML content after opening the window
      const res = await axios.get(`${BASE_URL}/view/${invoiceId}`);
      const html = res.data;

      // Write content to the new window
      newWindow.document.write(html);
      newWindow.document.close();

      // Print after load
      newWindow.onload = () => {
        newWindow.focus();
        newWindow.print();
      };
    } catch (error) {
      newWindow.document.write('<h3>Error loading invoice</h3>');
      newWindow.document.close();
      console.error('Error viewing invoice:', error);
    }
  },
  // ✅ Update invoice status
async updateStatus(invoiceId, status) {
  try {
    const res = await axios.put(
      `${BASE_URL}/${invoiceId}/status`,
      { status }, // 👈 send as an object, not JSON string
    );
    return res.data;
  } catch (error) {
    console.error("Error updating invoice status:", error);
    throw error;
  }
}



};

export default invoiceService;
